import React from 'react';

/**
 * Button component with action feedback states
 * @param {Function} onClick - Click handler function
 * @param {React.ReactNode} children - Button content
 * @param {string} [className] - Optional CSS classes
 */
const ActionButton = ({onClick, text}) => {
  return (
    <button
      className={`w-full px-4 py-2 text-sm font-medium text-white 
        bg-gray-500 rounded-md 
        transition-all duration-200 ease-in-out
        hover:bg-gray-600 
        active:bg-gray-700 active:transform active:scale-95 active:ring-2 active:ring-offset-2 active:ring-gray-500
        focus:outline-none`}
      onClick={onClick}
    >
        {text}
    </button>
  );
};

export default ActionButton;